import { Component } from '@angular/core';

@Component({
  selector: 'app-delete-produck-dialog',
  templateUrl: './delete-product-dialog.component.html',
  styleUrls: ['./delete-product-dialog.component.scss'],
})
export class DeleteProductDialogComponent {}
